import { render, staticRenderFns } from "./customer-remark.modal.vue?vue&type=template&id=0ae14df8&"
import script from "./customer-remark.modal.vue?vue&type=script&lang=ts&"
export * from "./customer-remark.modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports